import { Icon } from '../../components/ui/Icon';
import type {
  User,
  Role,
  PermissionMatrix,
  Suite,
  PermLevel,
} from '../../data/types/platform';

export interface AdminRolesProps {
  users: User[];
  roles: Role[];
  perms: PermissionMatrix;
  suites: Suite[];
}

function lvlLabel(lvl: PermLevel | null | undefined): string {
  if (lvl === 'admin') return 'ניהול';
  if (lvl === 'edit')  return 'עריכה';
  if (lvl === 'view')  return 'צפייה';
  return '—';
}

export function AdminRoles({ users, roles, perms, suites }: AdminRolesProps) {
  return (
    <div className="admin-roles">
      <div className="admin-section-head">
        <h2>תפקידים מוגדרים</h2>
        <button className="admin-btn ghost" type="button">
          <Icon name="plus" size={14} />
          הוסף תפקיד
        </button>
      </div>
      <div className="role-grid">
        {roles.map((r) => {
          const memberCount = users.filter((u) => u.role === r.id).length;
          const rolePerms = perms[r.id] || {};
          const access = Object.entries(rolePerms).filter(([, v]) => v) as Array<[string, Exclude<PermLevel, null>]>;
          return (
            <div key={r.id} className="role-card">
              <div className="role-card-head">
                <span className={'role-pill role-' + r.id}>
                  <span className="role-pill-short">{r.short}</span>
                  {r.he}
                </span>
                <span className="role-members">{memberCount} משתמשים</span>
              </div>
              <p className="role-desc">{r.desc}</p>
              <div className="role-perms">
                {access.length === 0 ? (
                  <span className="cell-dim">אין הרשאות מוגדרות</span>
                ) : (
                  access.map(([sysId, lvl]) => {
                    const s = suites.find((x) => x.id === sysId);
                    return (
                      <span key={sysId} className={'role-perm-chip lvl-' + lvl}>
                        <Icon name={s?.icon} size={11} />
                        {s?.he}
                        <span className="role-perm-lvl">{lvlLabel(lvl)}</span>
                      </span>
                    );
                  })
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
